//
// Handling für alle API anfragen
//

import { getCookieValue, isIframe, isLoggedIn, parseJwt } from "./helper";

const apiBaseUri = process.env.API_URL;

async function apiRequest(path, method, credentials) {
    if (isIframe()) { return null; }

    if (!isLoggedIn()) {
        console.log("[Api Request] Not logged in: " + path);
        return null;
    }

    return await fetch(apiBaseUri + path, {
        method: method,
        credentials: 'include',
    }).catch(error => {
        console.error("API Connection Error: " + error);
    }).then(res => {
        if (typeof res == "undefined") {
            return null;
        } else if (res.ok) {
            return res.json();
        } else {
            console.error("API Error: " + res.status + " " + res.statusText);
            return null;
        }
    });
}

export async function readArticleApi(articleId) {
    return await apiRequest("/artikel?artikel=" + articleId, "POST", true);
}

export async function readManyArticleApi(articleIds) {
    return await apiRequest("/artikel?artikel=" + articleIds.join(","), "POST", true);
}

export async function unreadArticleApi(articleId) {
    return await apiRequest("/artikel?artikel=" + articleId, "DELETE", true);
}

export async function getArticlesApi() {
    return await apiRequest("/artikel", "GET", true);
}

export async function getUnreadContentApi(year) {
    return await apiRequest("/ungeleseneinhalte?jahr=" + year, "GET", true);
}

export async function getArtikelGemerkt(articleId) {
    return await apiRequest("/gemerkterartikel?artikel=" + articleId, "GET", true);
}

export async function setArtikelGemerkt(articleId) {
    return await apiRequest("/gemerkterartikel?artikel=" + articleId, "POST", true);
}

export async function removeArtikelGemerkt(articleId) {
    return await apiRequest("/gemerkterartikel?artikel=" + articleId, "DELETE", true);
}

export async function getAutorGefolgt(autorId) {
    return await apiRequest("/gefolgterautor?autor=" + autorId, "GET", true);
}

export async function getAlleAutorGefolgt() {
    return await apiRequest("/gefolgterautor", "GET", true);
}

export async function setAutorGefolgt(autorId) {
    return await apiRequest("/gefolgterautor?autor=" + autorId, "POST", true);
}

export async function removeAutorGefolgt(autorId) {
    return await apiRequest("/gefolgterautor?autor=" + autorId, "DELETE", true);
}

export async function getThemaGefolgt(themaId) {
    return await apiRequest("/gefolgtesthema?thema=" + themaId, "GET", true);
}

export async function getAlleThemaGefolgt() {
    return await apiRequest("/gefolgtesthema", "GET", true);
}

export async function setThemaGefolgt(themaId) {
    return await apiRequest("/gefolgtesthema?thema=" + themaId, "POST", true);
}

export async function removeThemaGefolgt(themaId) {
    return await apiRequest("/gefolgtesthema?thema=" + themaId, "DELETE", true);
}

export async function getInformationsdienstGefolgt(informationsdienstId) {
    return await apiRequest("/gefolgterinformationsdienst?informationsdienst=" + informationsdienstId, "GET", true);
}

export async function getAlleInformationsdienstGefolgt() {
    return await apiRequest("/gefolgterinformationsdienst", "GET", true);
}

export async function setInformationsdienstGefolgt(informationsdienstId) {
    return await apiRequest("/gefolgterinformationsdienst?informationsdienst=" + informationsdienstId, "POST", true);
}

export async function removeInformationsdienstGefolgt(informationsdienstId) {
    return await apiRequest("/gefolgterinformationsdienst?informationsdienst=" + informationsdienstId, "DELETE", true);
}

export async function readDownloadApi(downloadId) {
    return await apiRequest("/downloads?download=" + downloadId, "POST", true);
}

export async function unreadDownloadApi(downloadId) {
    return await apiRequest("/downloads?download=" + downloadId, "DELETE", true);
}

export async function getreadDownloadsApi() {
    return await apiRequest("/downloads", "GET", true);
}

export async function readManyDownloadsApi(articleIds) {
    return await apiRequest("/downloads?download=" + articleIds.join(","), "POST", true);
}